export const FREE_TRIAL_SCHEDULE = "Thursdays and Fridays at 6:00 PM";

type FreeTrialScheduleProps = {
  className?: string;
};

export function FreeTrialSchedule({ className = "" }: FreeTrialScheduleProps) {
  return (
    <p className={`text-sm text-gray-400 ${className}`.trim()}>
      Free trial sessions are currently offered {FREE_TRIAL_SCHEDULE}.
    </p>
  );
}
